<template>
  <div class="login-outer-container scroll-outer" :class="containerClass">

    <div class="gutter-horizontal-IEonly login-inner-container content-translate" :class="innerClass">
    
    <!-- Sign In -->

    <div v-if="logInModal" class="pad-60">

      <p class="content-translate text-center color-red" :class="statusClass">{{status}}</p>

      <h1 class="upcase text-center">sign in</h1>

      <div class="row">
        <div class="span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
          <input type="text" class="form-text-area text-area-small p " v-model="user.email" placeholder="email" v-on:keydown="checkForEnter" />
        </div>
        <div class="span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
          <input type="password" class="form-text-area text-area-small p " v-model="user.password" placeholder="password" v-on:keydown="checkForEnter" />
        </div>
      </div>

      <div class="row  margin-top-24">
        <div class="span-7-lg offset-3-lg span-11-md offset-1-md span-11-sm offset-1-sm span-11-xs offset-1-xs margin-right-12-lg margin-right-12-md hide-xs ">
          <p class="a" v-on:click="toggleModal">Don't have an account? Sign Up</p>
        </div>
        <div class="span-3-lg span-3-md span-3-sm span-14-xs offset-1-xs ">
          <nav-button type="next" customclass="float-right call-to-action" v-bind:clickevent="logIn">Login</nav-button>
        </div>
        <div class="span-14-xs offset-1-xs show-xs">
          <p class="a text-center" v-on:click="toggleModal">Don't have an account? Sign Up</p>
        </div>
      </div>

      <div class="max-small">
        <p class="text-center "><em><strong>Please make note of your login and password information.</strong> If these are misplaced, you will need to create a new login by notifying us at <a href="mailto:kcoleman@futureswithoutviolence.org">kcoleman@futureswithoutviolence.org</a> and restarting the module from the beginning.</em></p>
      </div>


    </div>

    <!-- Sign Up -->

    <div v-if="signUpModal" class="pad-60">

      <p class="content-translate text-center color-red" :class="statusClass">{{status}}</p>

      <h1 class="upcase text-center">Sign Up</h1>

      <div class="row">
        <div class="span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
          <input type="text" class="form-text-area text-area-small p " v-model="newUser.firstName" placeholder="first name" />
        </div>
        <div class="span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
          <input type="text" class="form-text-area text-area-small p " v-model="newUser.lastName" placeholder="last name" />
        </div>
      </div>

      <div class="row">
        <div class="span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
          <input type="email" class="form-text-area text-area-small p " v-model="newUser.email" placeholder="email" />
        </div>
      </div>

      <div class="row">
        <div class="span-5-lg offset-3-lg margin-right-12-lg span-7-md offset-1-md margin-right-12-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
          <input type="password" class="form-text-area text-area-small p " v-model="newUser.password" placeholder="password" />
        </div>
        <div class="span-5-lg span-7-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
          <input type="password" class="form-text-area text-area-small p " v-model="confirmPassword" placeholder="confirm password" />
        </div>
      </div>

      <div class="row margin-top-24">
        <div class="span-7-lg offset-3-lg span-11-md offset-1-md span-11-sm offset-1-sm span-11-xs offset-1-xs margin-right-12-lg margin-right-12-md hide-xs ">
          <p class="a" v-on:click="toggleModal">Already have an account? Sign In</p>
        </div>
        <div class="span-3-lg span-3-md span-3-sm span-14-xs offset-1-xs ">
          <nav-button type="next" customclass="float-right call-to-action" v-bind:clickevent="register">Submit</nav-button>
        </div>
        <div class="span-14-xs offset-1-xs show-xs">
          <p class="a text-center" v-on:click="toggleModal">Already have an account? Sign In</p>
        </div>
      </div>

    </div>

    <!-- Resume -->

    <div v-if="continueCondition" class="pad-60">

      <h1 class="upcase text-center">{{status}}!</h1>

      <div class="row margin-top-24" v-if="showContinueControls">
        <div class="span-7-lg offset-3-lg span-11-md offset-1-md span-11-sm offset-1-sm span-11-xs offset-1-xs margin-right-12-lg margin-right-12-md hide-xs ">
          <p class="a" v-on:click="logOut">Not you? Switch user</p>
        </div>
        <div class="span-3-lg span-3-md span-3-sm span-14-xs offset-1-xs">
          <nav-button type="next" customclass="float-right call-to-action" v-bind:clickevent="loginSuccess">Resume</nav-button>
        </div>
        <div class="span-14-xs offset-1-xs show-xs">
          <p v-on:click="logOut" class="a text-center">Not you? Switch user</p>
        </div>
      </div>

    </div>

    <!--  -->

  </div>
  </div>
</template>

<script>
  import button from '../molecules/button'
  
  import {apiUrls} from '../../utils/api_addresses'
  import valid_email from '../../utils/valid_email'
  import "babel-polyfill" // axios IE polyfill
  import axios from 'axios'
  // axios.defaults.withCredentials = true;

  export default {
    data () {
      return {
        status: '',
        continuePage: false,
        modal: 'logIn',
        user: {
          email: '',
          password: ''
        },
        newUser: {
          firstName: '',
          lastName: '',
          email: '',
          password: ''
        },
        confirmPassword: '',
        containerClass: '',
        innerClass: '',
        showContinueControls: true
      }
    },
    computed: {
      continueCondition () {
        if(this.continuePage || this.continuePage === 0) return true
        return false
      },
      logInModal () {
        return this.modal === 'logIn' && !this.continueCondition
      },
      signUpModal () {
        return this.modal === 'signUp' && !this.continueCondition
      },
      statusClass () {
        return this.status ? '' : 'content-inactive'
      }
    },
    methods: {
      checkForEnter (e) {
        if (e.keyCode === 13) {
          this.logIn()
        }
      },
      toggleModal () {
        this.innerClass = 'content-inactive'
        setTimeout (() => {
          this.modal = this.modal === 'logIn' ? 'signUp' : 'logIn'
          this.status = ''
          this.innerClass = ''
        }, 1000)
      },
      setUser (data, prefix) {
        this.innerClass = 'content-inactive'
        setTimeout(() => {
          this.status = prefix + data.firstName
          this.continuePage = data.page
          this.innerClass = ''
        }, 1000)
      },
      logIn () {
        axios.post(apiUrls.server.login, this.user, {withCredentials: true})
        .then((response) => {
          if(!response.data.authorized) {   
            this.status = "Incorrect email address or password"
            this.continuePage = false
          } else {
            this.setUser(response.data, "Welcome back, ")
            this.showContinueControls = false
            setTimeout(() => {
              this.loginSuccess()
            }, 2000)
          }
        })
      },
      logOut () {
        axios.get(apiUrls.server.logout, {withCredentials: true})
        .then((response) => {
          this.setUser({
            firstName: '',
            continuePage: false
          }, '')
        })
      },
      register () {

        // validations

        // incomplete fields
        for( let key in this.newUser) {
          if (this.newUser[key] === '') {
            this.status = "Please complete all fields"
            return false
          }
        }

        //invalid first or last name
        if(!/^[a-zA-Z]*$/.test(this.newUser.firstName) || !/^[a-zA-Z]*$/.test(this.newUser.lastName)){
          this.status = "Names can only contain letters and spaces"
          return false
        }

        // invalid email
        if (!valid_email(this.newUser.email)) {
          this.status = "Please provide a valid email address"
          return false
        }

        // password match
        if (this.confirmPassword !== this.newUser.password) {
          this.status = "Passwords do not match"
          return false
        }

        axios.post(apiUrls.server.register, this.newUser, {withCredentials: true})
        .then((response) => {
          if (!response.data.authorized)  {
            this.status = "A user with that email already exists!"
            this.continuePage = false
          } else {
            this.setUser(response.data, "welcome, ")
            this.setSession()
            this.showContinueControls = false
            setTimeout(() => {
              this.loginSuccess()
            }, 2000)
          }
        })

      },
      // HANDLE session server side.
      setSession () { // aka login without callback
        axios.post(apiUrls.server.login, this.newUser, {withCredentials: true})
      },
      checkSession () {
        axios.get(apiUrls.server.authenticate, {withCredentials: true})
        .then((response) => {
          if (!response.data.authorized)  {
            this.continuePage = false
          } else {
            this.setUser(response.data, "Welcome back, ")
          }
        })
      },
      loginSuccess () {
        // assign page and then change in loginSuccess to trigger active watchers
        // set to 1 instead of 0 because tempalte at 0 sets callbacks that disable navigation.
        this.$store.commit('assign_page', 1)
        // go to user's current page and hide login screen.
        this.$store.commit('setLoggedIn', true)
        setTimeout(() => {
          this.$store.commit('assign_page', this.continuePage)
        })
        setTimeout(() => {
          this.containerClass = 'hide-login-container'
        }, 400)
        setTimeout(() => {
          let prev = this.containerClass
          this.containerClass = prev + ' hide-all'
        }, 400 + 400)
      }
    },
    components: {
      'nav-button': button
    },
    mounted () {
      this.checkSession()
    }
  }
</script>


<style scoped lang="scss">
  @import '../../styles/variables';

  // forgot password text

  .max-small {
    position: relative;
    text-align: center;
    // background: blue;
    margin: auto;
    padding-top: 12px;
    width: 60%;
    a {
      color: $orange !important;
    }
    @media screen and (max-width: $sm-max) {
      // max-width: calc(100% - 24px);
      width: calc(100% - 60px);
    }
  }
  
  .login-outer-container {
    position: fixed !important;
    top: 0;
    left: 0;
    margin-top: 0px;
    margin-left: 0px;
    width: 100%;
    height: 100%;
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $body-bg;
    transition: all $transition-1;
    &.hide-login-container {
      opacity: 0;
      pointer-events: none;
    }
  }

  .pad-60 {
    background: white;
    position: relative;
    margin: auto;
    padding-top: 60px;
    padding-bottom: 60px;
  }
  
</style>


// WEBPACK FOOTER //
// login.vue?f3630712